module.exports = __webpack_public_path__ + "img/huddersfield-town-afc.4c949263.png";